// La dirección PÚBLICA de verificación de una credencial cd-2b: lo que el asesor comparte y lo que lleva el QR del certificado.
//
// Antes el portal copiaba `origin.replace('portal', 'coredeskpro')/certificacion/verificar/<slug>` (otro sitio, el del producto legal) y
// «Abrir» iba a una ruta del propio portal del asesor: las dos daban 404. La página vive en el sitio de cd-2b del MISMO entorno que la API.

const ESCAPARATES = {
  'api.coredeskpro.com': 'https://cd-2b.com',
  'api-s.coredeskpro.com': 'https://cd2b-s.coredeskpro.com',
}

/** `null` si no conocemos el sitio de este entorno: mejor sin enlace que apuntar a uno equivocado. */
export function urlVerificacion(slug, apiUrl) {
  if (!slug) return null
  let host = ''
  try {
    host = new URL(apiUrl).hostname.toLowerCase()
  } catch {
    return null
  }
  const base = ESCAPARATES[host]
  return base ? `${base}/certificacion/verificar/${encodeURIComponent(slug)}` : null
}
